const listeners = new Set();
export const quarantineText = quarantine => `This chat is quarantined for security review (${quarantine?.reasons?.map(reason => reason.label).filter(Boolean).join(', ') || 'Security review'}). You can read it, but replies and actions are disabled until a manager releases it.`;
export const subscribeQuarantineDenied = listener => { listeners.add(listener); return () => listeners.delete(listener); };
export function reportQuarantineDenied(error, endpoint, session) {
  if (error.status !== 403 || error.code !== 'CONVERSATION_QUARANTINED' || session !== localStorage.getItem('accessToken')) return;
  const match = endpoint.match(/^\/conversations\/([^/]+)/);
  if (match) listeners.forEach(listener => listener(decodeURIComponent(match[1])));
}
